// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon_Icon__2YQcb","Icon_button":"Icon_Icon_button__2B5h9","Icon__icon":"Icon_Icon__icon__20r-Z"};